import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Button,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastSuccess } from "../../../helpers/msg_helper"
import { Link, Navigate, useNavigate } from "react-router-dom"
import {
  searchMaterialRequest,
  updateAction,
  updateManPowerStatus,
  updateSupplierStatus,
} from "../../../services/procurement/materialrequest"
// import MaterialFilter from "./filter"
import moment from "moment"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { searchManpowerhRequest } from "../../../services/projectManager/projectMaster"
import Designation from "../../Hrms/designation"
import NumberFormat from "../../../utils/numberFormat"

const ManPowerRequest = ({ fromDashboard, projectId }) => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Manpower Request${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [manPowerData, setManPowerData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [mrno, setMRNo] = useState("")
  const [page, setPage] = useState("")
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [financial, setFinancial] = useState(true)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  // const handleActivate = item => {
  //   const updateStatus = async item => {
  //     const response = await updateSupplierStatus(item)
  //     toastSuccess(response?.message)
  //     setRefresh(refresh + 1)
  //   }
  //   updateStatus(item)
  // }

  const handleAction = async data => {
    const response = await updateManPowerStatus(data)
    toastSuccess(response?.message)
    setRefresh(refresh + 1)
  }

  const columns = [
    {
      label: "M-Code",
      renderCell: item => {
        return (
          <>
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "manpowerrequest_view"
            ) ? (
              <div
                onClick={() => navigate(`/procurement-manpower-req/view/${item.id}`)}
                className="pointer fw-bold"
              >
                {item?.manpower_code}
              </div>
            ) : (
              <div>{item?.manpower_code}</div>
            )}
          </>
        )
      },
    },
    {
      label: "Designation",
      renderCell: item => item?.designation?.name || "-",
    },
    {
      label: "Project Code",
      renderCell: item => item?.project_id?.project_code,
    },
    {
      label: "From date",
      renderCell: item => moment(item?.from_date).format("DD-MM-YYYY"),
    },
    {
      label: "To date",
      renderCell: item => moment(item?.to_date).format("DD-MM-YYYY"),
    },
    {
      label: <div className="text-end pe-5">Number of Hours</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.req_manpower_no))}
        </div>
      ),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.status === 1
                ? "status-active"
                : item?.status === 0
                  ? "status-posted"
                  : "status-inactive"
              }`}
          >
            {item?.status === 0
              ? "New"
              : item?.status === 1
                ? "Accept"
                : "Reject"}
          </span>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item =>
        fromDashboard ? (
          item?.request_status == 0 ? (
            <>
              <div>
                <Button
                  color={"primary"}
                  className="btn btn-primary me-2"
                  onClick={() =>
                    handleAction({ manPowerReq: item?.id, status: 1 })
                  }
                >
                  Accept
                </Button>
                <Button
                  className="hover-button"
                  onClick={() =>
                    handleAction({ manPowerReq: item?.id, status: 2 })
                  }
                >
                  Reject
                </Button>
              </div>
            </>
          ) : (
            <></>
          )
        ) : (
          <>
            <div>
              <span id={`PopoverLegacy-${item?.id}`}>
                <img src={action} alt="" className="pointer" />
              </span>
            </div>
            <UncontrolledPopover
              placement="bottom"
              target={`PopoverLegacy-${item?.id}`}
              trigger="legacy"
            >
              <PopoverBody>
                {item?.request_status == 0 && (
                  <>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        handleAction({ manPowerReq: item?.id, status: 1 })
                      }
                    >
                      Accept
                    </div>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        handleAction({ manPowerReq: item?.id, status: 2 })
                      }
                    >
                      Reject
                    </div>
                  </>
                )}
                {/* <div
                className={`table-popup-content`}
                // onClick={() => handleActivate(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div> */}
              </PopoverBody>
            </UncontrolledPopover>
          </>
        ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }
  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }
  useEffect(() => {
    const fetchManPower = async () => {
      const response = await searchManpowerhRequest({
        params: `${"&searchText"}${projectId ? `&project_id=${projectId}` : ""
          }${`&sortOrder=asc`}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setManPowerData(response)
      const newData = response?.data?.data || [];

      setManPowerData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
      console.log("value", response?.data?.data)
      console.log("data", manPowerData)
    }
    fetchManPower()

    //     const response = await searchMaterialRequest({
    //     params: `${
    //       status == "0" || status == "1" || status == "2"
    //         ? `&status=${status}`
    //         : ""
    //     }${search ? `&searchText=${search}` : "&searchText"}${
    //       mrno ? `&mr_no=${mrno}` : ""
    //     }${datefrom ? `&requestdate_from=${datefrom}` : ""}${
    //       dateto ? `&requestdate_to=${dateto}` : ""
    //     }${
    //       page ? `&page=${page}` : ""
    //     }${`&financial=${financial}`}${`&sizePerPage=10`}${
    //       fromDashboard ? `&filter_status=0` : ""
    //     }${fromDashboard && projectId ? `&project_id=${projectId}` : ""}`,
    //   })
    //   setMaterialRequest(response)
    // }
    // fetchMaterialRequest()
  }, [refresh, status, search, mrno, page, datefrom, dateto, financial, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < manPowerData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [manPowerData, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleRequestChange = id => {
    setMRNo(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  return (
    <React.Fragment>
      <div
        className={`${fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
          }`}
      >
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <Breadcrumbs
                title="Project Management"
                breadcrumbObject={[
                  { title: "Project Management", link: "/project" },
                  {
                    title: "Manpower Request",
                    link: "/project-manpowerreq",
                  },
                ]}
              />
            ) : (
              <></>
            )}
            {loggedUser?.permission?.some(
              permissionItem =>
                permissionItem?.name === "manpowerrequest_create"
            ) && (
                <Link
                  to="/project-manpowerreq/add"
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                >
                  {"+ Manpower Request"}
                </Link>
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            {/* <MaterialFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleRequestChange={handleRequestChange}
              handleDateChange={handleDateChange}
              handleFinacialChange={handleFinacialChange}
              sampleUrl={"download/suppliers.xlsx"}
              importUrl={"suppliers/import"}
              isImport={false}
            /> */}
            {/* <hr className="table-divide" /> */}
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "550px", overflowY: "auto" }}>
                {manPowerData && (
                  <UpdateTable
                    className="mt-5"
                    nodes={manPowerData?.data?.data}
                    paginate={manPowerData?.data}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5%"
                    mobileWidth="30% 30% 30% 30% 30% 20% 15% "
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ManPowerRequest
